// extracted by mini-css-extract-plugin
export default {"highlight":"highlight___jWiez_common"};
    if(module.hot) {
      // 1787836817994
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  